import { render, staticRenderFns } from "./sentenceM5.vue?vue&type=template&id=0f76a550&scoped=true&"
import script from "./sentenceM5.vue?vue&type=script&lang=js&"
export * from "./sentenceM5.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM5.vue?vue&type=style&index=0&id=0f76a550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76a550",
  null
  
)

export default component.exports